import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentEmpleados } from '@environments/environment';

import { Observable } from 'rxjs';
import { stringify } from '@angular/compiler/src/util';

@Injectable({
  providedIn: 'root'
})
export class LicenseApplicationService {

  constructor(private http: HttpClient) { }

  getLicenseApplicationReason() {
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/LicenseApplicationReason`);
  }

  getLicenseApplicationType() {
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/LicenseApplicationType`);
  }

  post(form: any) {

    let json = JSON.stringify(form)

    console.log("json", json)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/LicenseApplication/CurrentUser`,form );
  }

  postPreviewDSP13(form: any){
    

    console.log("json preview dsp13", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/LicenseApplication/CurrentUserGetPdfPreview`,form );
  }
  
}
